import $models from '@/models'
import moment from '@/moment-gp'
import util from '@/util'
// import { set_ready } from './misc'
// import $store from '@/store'
import resourceLoader from '@/resource-loader'

import { instantiate_goal_from_template } from "@/models/goal/goalMeta/util";
// import userGoalInvitationModelDefinition from '@/models/user/userGoalInvitation'

const $goalMeta = $models.goalMeta;
const $userGoalSettings = $models.userGoalSettings;
const $goalMember = $models.goalMember;
const $goalMemberPrivacySettings = $models.goalMemberPrivacySettings;

/* =========================== Helper functions ============================= */

const log = (...args) => { console.log("[API:goal]", ...args) };

/* ================================ Actions ================================= */

export function goal_create({
  name, picture, isTeamgoal,
  dataMeta = null,
  dataUser = {},
  userPublic = null
}) {

  if ( !name ) {
    throw new Error('Invalid name', name)
  }

  let creatorUserId = $models.user.defaultUserId;
  // let userData = $store.getters["user/userData"];
  userPublic = userPublic || $models.userPublic.getNode( $models.user.defaultUserId ).$state

  // let new_goal_data = $goalMeta.empty({ name, creatorUserId, userPublic, picture, isTeamgoal })
  let new_goal_model = $goalMeta.new_from_template({
    name, creatorUserId, userPublic, picture, isTeamgoal, ...dataMeta })

  /* Make sure document does not exist */
  // TODO: No schema validation here
  return new Promise((resolve, reject) => {

    // console.log("[goal_create] meta payload", new_goal_data);
    console.log("[goal create] model", new_goal_model)

    new_goal_model.write().then(new_goal_id => {
    // $goal.add({ meta: new_goal_data }, null, { directWrite: true }).then(new_goal_id => {
      // TODO: Decide if goals or workspaces are used

      let user_goal_data = {
        cachedName: name,
        sortidx: dataUser.sortidx || $goalMeta.getters.get_last_sortidx,
        ...dataUser
      }

      /* Add goal to user goal list */
      add_goal_to_user({
        goal_id: new_goal_id,
        user_goal_data: user_goal_data
      }).then(resolve);
    });
  })
}

// -----------------------------------------------------------------------------
export function goal_instantiate({ template }) { // <OK>

  let creatorUserId = $models.user.defaultUserId;
  let userPublic = $models.userPublic.getNode( $models.user.defaultUserId ).$state
  // let userPublic = $store.getters["user/userPublic"];

  let { goal, userGoal } = instantiate_goal_from_template(
    creatorUserId, userPublic, template );

  let new_goal_id = $goalMeta._get_uid();

  $goalMeta.add(goal, new_goal_id).then(() => {
    userGoal.sortidx = $goalMeta.getters.get_last_sortidx;
    add_goal_to_user({
      goal_id: new_goal_id,
      user_goal_data: userGoal
    });
  });

  // Does not return a promise!
  return new_goal_id;
}

// -----------------------------------------------------------------------------

export function goal_delete({ goal_id, hard_delete = false }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( hard_delete ) {

    /* Set ready flag to false */
    resourceLoader.dettachGoal( goal_id )

    /* Send delection request */
    return $goalMeta.update(goal_id, {
      goalDeletionRequest: moment.currentTimeServer('REALTIMEDB')
    })

  } else {
    return $goalMeta.remove( goal_id, true );
  }
}

// -----------------------------------------------------------------------------

export function goal_update({ data, goal_id }) { // <OK>

  log("goal_update", goal_id, data);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  /* Convert 'Date' to firestore 'Timestamp' */
  if ( 'deadlineList' in data ) {
    data.deadlineList.forEach((deadline, idx) => {
      data.deadlineList[idx].date =
        deadline.date = deadline.date.toFirestore();
    })
  }

  return $goalMeta.update( goal_id, data )
}

// -----------------------------------------------------------------------------

export function goal_update_name({ goal_id, name }) { // <OK>

  let payload = { name: name };

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  log("changing name: submitting payload", payload);

  return $goalMeta.update(goal_id, payload).then(() => {
    // TODO: Decide if goals or workspaces are used

    /* Update cached name in user goal too */
    $userGoalSettings.update( goal_id, { cachedName: name } );

    /* Finally don't forget to update local state */
    // $store.commit("goal/GOAL_SET_NAME", { id: goal_id, name: name }); // ?

    // TODO: What about other users??
    // Update name on load
  });
}

// -----------------------------------------------------------------------------

export function goal_remove_member({ goal_id, user_id } ) { // <OK>

  // TODO: Make sure that owner does not delete himself
  // TODO: Also remove pending invitations!

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( user_id ) ) { // TODO: isValidUserId
    throw new Error('Invalid user_id', user_id)
  }

  // TODO: This does not remove the users internal entry

  log("goal_remove_member");
  return $goalMember.with({ goalId: goal_id }).remove(user_id);
}

// -----------------------------------------------------------------------------

export function goal_update_user_permissions({ goal_id, user_id, isAdmin }) { // <OK>
  log("goal_update_user_permissions", goal_id, user_id, isAdmin );

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( user_id ) ) { // TODO: isValidUserId
    throw new Error('Invalid user_id', user_id)
  }

  log("goal_update_user_permissions", { isAdmin });
  return $goalMember.with({ goalId: goal_id }).update(user_id, { isAdmin });
}

// -----------------------------------------------------------------------------

export function goal_add_privacy_settings({ goal_id, other_user_id }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  let currentUserId = $models.user.defaultUserId;

  if ( !(util.isValidId( other_user_id ) || other_user_id === 'TEAM')
    || other_user_id === currentUserId ) {
    throw new Error('Invalid other_user_id', other_user_id)
  }

  $goalMemberPrivacySettings
    .with({ goalId: goal_id, memberId: currentUserId })
    .add( {}, other_user_id );
}

// -----------------------------------------------------------------------------

export function goal_update_privacy_settings({ goal_id, other_user_id, privacy_settings }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  let currentUserId = $models.user.defaultUserId;

  if ( !(util.isValidId( other_user_id ) || other_user_id === 'TEAM')
    || other_user_id === currentUserId ) {
    throw new Error('Invalid other_user_id', other_user_id)
  }

  $goalMemberPrivacySettings
    .with({ goalId: goal_id, memberId: currentUserId })
    .update( other_user_id, privacy_settings);

}

// -----------------------------------------------------------------------------

export function goal_rem_privacy_settings({ goal_id, other_user_id }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( other_user_id ) ) { // TODO: isValidUserId
    throw new Error('Invalid other_user_id', other_user_id)
  }

  let currentUserId = $models.user.defaultUserId;

  $goalMemberPrivacySettings
    .with({ goalId: goal_id, memberId: currentUserId })
    .remove( other_user_id );
}

// =============================================================================

// TODO: Move to userGoalSettings ?

export function add_goal_to_user({ goal_id, user_goal_data, directWrite = false }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  /* Add goal to user goal list */
  /*
  let payload = {
    [`goals.${goal_id}`]: true // set goal to visible = load at startup
  };

  let promise = userqueries.user.update(payload).then(() => {
    log( "Successfully added goal to visible users goal list", payload );
    // INFO: Update does not happen automatically
  });
  */

  // TOOD: why add - when we already provide a fully defined goal
  let promise = $userGoalSettings.add(user_goal_data, goal_id, { directWrite })
  .then((new_goal_id) => {
    log( "Successfully added goal to /users/<UID>/goal", user_goal_data );
    return new_goal_id
  });

  /* Attach goal */
  // TODO: Warum nicht attachGoal?
  /*
  // TODO: We also need a mechasism for goals created by others or cloud
  resourceLoader.attachGoal( goal_id, false )

  */
  // $store.commit("goal/LOAD_GOAL", goal_id);
  return promise;
}

// -----------------------------------------------------------------------------

/*
  Update projec fields
  */
export function update_user_goal({ goal_id, data }) { // <OK>

  log("update_user_goal", data);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  return $userGoalSettings.update( goal_id, data );
}

// -----------------------------------------------------------------------------

export function goal_add_member({ goal_id, user_id, data = {} }) { // <OK>
// export function invite_to_goal_by_userid({ goal_id, user_name, user_pic, user_id }) { // <OK>

  // TODO: DO not send invitation, it's handles somwhere else

  // TODO: Check user rights
  // TODO: Create on server?
  // TODO: Bei update (nicht invite) sollten einige Felder nicht überschrieben werden

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  /* Check for valid user UUID and then submit invitation */
  if ( !util.isValidId( user_id ) ) {
    throw new Error('Invalid user_id', user_id)
  }

  // Convert to Teamgoal
  let goalMetaUpdatePromise = $goalMeta.update( goal_id, { isTeamgoal: true } )

  // INFO: fetch is required for node
  let member_list_model = $goalMember.with({ goalId: goal_id }).fetchList()
  let user_being_added = $models.userStatus.fetchNode( user_id );

  return Promise.all([ member_list_model.$promise, user_being_added.$promise ]).then(() => {

    /* Check if user is alreay a member */
    // let member_ids = this.members_as_array.map(member => member.$id);
    if ( user_id in member_list_model.items ) {
      return Promise.resolve({
        message: {
          message: 'User ' + member_list_model.items[ user_id ].displayName + ' already exist.',
          type: 'info'
        }
      });
    }

    log("goal_add_member", goal_id, user_id );

    /*
    let profile_pic = data.profile_pic === undefined
      ? $models.userSettings.getters.get_profile_pic
      : data.profile_pic
    let display_name = data.display_name === undefined
      ? firebase.auth().currentUser.displayName // Does not work wih node
      : data.display_name
    */

    let goal_member = $goalMember.with({ goalId: goal_id }).new_from_template({
      displayName: user_being_added.displayName,
      userPicture: user_being_added.profilePic,
      isCreator:   false,
    })

    goal_member.isOwner = false;
    goal_member.isAdmin = data.isAdmin || true; // NEW DEFAULT
    goal_member.acceptOrDecline = data.acceptOrDecline || goal_member.acceptOrDecline;

    log("goal_add_member", goal_member);
    goal_member.$id = user_id; /* overwrite id */
    let addMemberPromise = goal_member.write();

    // HACK
    let sendInvitationPromise = Promise.resolve();

    /* Use goal name from loaded goal not cached goal name */
    /*
    // TODO: move to user and make generic invitation function
    let goal = $models.goalMeta.getNode( goal_id );
    // let goal = $store.getters['goal/goal_by_id'](goal_id);
    let senderUserData = $store.getters["user/userData"];
    let senderUserData = $models.userSettings.getNode( $models.user.defaultUserId ).$state

    // TODO: No data validation here! (This is firestore)
    let invite_data = userGoalInvitationModelDefinition.schema.create({
      projectName:  goal.name,
      senderUserId: $models.user.defaultUserId,
      firstName:    senderUserData.firstName,
      lastName:     senderUserData.lastName
    })

    let invite_payload = {};
    Object.keys(invite_data).forEach(key => {
      invite_payload[`goalInviteList.${goal_id}.${key}`] = invite_data[key];
    });

    log("goal_add_member inviting user", invite_payload);
    // TODO: This does not return a promise
    let sendInvitationPromise = userqueries
      .userPrivateDocumentQuery(user_id)
      .update(invite_payload);
    */

    return Promise.all([ goalMetaUpdatePromise, addMemberPromise, sendInvitationPromise ]).then(() => {
      return {
        message: {
          message: 'User successfully added',
          type: 'info'
        }
      }
    })
  })
}

// -----------------------------------------------------------------------------

/* export function invite_to_goal_by_email({ goal_id, email, role }) { // <OK>
  log("NOT IMPLEMENTED", goal_id, email, role);
  // TODO - Create a new User
  throw new Error("Currently not supported. We'll implemtend that very soon.");
} */

// -----------------------------------------------------------------------------

export function accept_or_decline_invitation({ goal_id, goal_name, accept }) { // <OK>
  log("accept_or_decline_invitation", goal_id, goal_name, accept );

  const NOTIFY_SENDER = true; // "NOTIFY_GOAL"
  let currentUserId = $models.user.defaultUserId;

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !goal_name ) {
    goal_name = 'Unknown name' // TODO: Async await fetch
  }

  let promiseAddGoalToUser = Promise.resolve();
  let promiseNotifyGoal = Promise.resolve();
  let promiseUpdatePrivateDocument = Promise.resolve();

  if (accept) {
    /* TODO: This should fetched from the server or at least be updated later */
    let new_empty_user_goal = $models.userGoalSettings.empty({
      cachedName: goal_name,
      sortidx: $goalMeta.getters.get_last_sortidx
    })

    console.log("accept_or_decline_invitation - new goal settings", new_empty_user_goal);
    // TODO: Direct write actually not necessary
    promiseAddGoalToUser = add_goal_to_user({
      goal_id: goal_id,
      user_goal_data: new_empty_user_goal,
      directWrite: true
    });
  }

  /* Let sender know that you declined or accepted */
  if ( NOTIFY_SENDER ) {
    let notify_payload = {
      acceptOrDecline: accept ? 1 : 2
    };

    log("notify_payload", notify_payload);
    promiseNotifyGoal = $goalMember
                          .with({ goalId: goal_id })
                          .update( currentUserId, notify_payload );

    // There was a return here - why?
  }

  /* remove invitation */
  // TODO: See new invitation API
  /*
  let invite_payload = {};
  let path = `goalInviteList.${goal_id}`;
  invite_payload[path] = firebase.firestore.FieldValue.delete();

  log("accept_or_decline_invitation - invite payload", invite_payload);
  promiseUpdatePrivateDocument = userqueries
                                 .userPrivateDocumentQuery(currentUserId)
                                 .update(invite_payload);
  */
  return Promise.all([
    promiseAddGoalToUser,
    promiseNotifyGoal,
    promiseUpdatePrivateDocument
  ]);
}

// -----------------------------------------------------------------------------

export function user_leave_goal( { goal_id, goal_exist } ) { // <OK>

  /* goal_exist - if a goal is deleted by another user, we will still have it in our goal settings
                  user_leave_goal( { goal_exist: false }) can be used to delete it */

  log("user_leave_goal", goal_id );

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  let onRemovedFromGoal = () => {

    log("SUCCESS: Removed myself from member list");

    // $goalMeta.remove( goal_id ) // WTF?

    $userGoalSettings.remove( goal_id )

    // $store.dispatch('goal/dettachGoal', { goal_id: goal_id });
    // $store.commit("goal/REM_GOAL", goal_id);
  }

  if ( goal_exist ) {

    /* Remove myself from member list */
    let user_id = $models.user.defaultUserId;
    return goal_remove_member({ goal_id, user_id }).then(onRemovedFromGoal)

  } else {
    onRemovedFromGoal()
    return Promise.resolve();
  }
}

// -----------------------------------------------------------------------------

export function goal_update_image({ goal_id, image_data }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function goal_deadline_add({ goal_id, deadline_id }) {
  // TODO: May be via:
  // let model = $models.goalMeta.getNode( goal_id )
  // model.deadline.push(...)
  // model.write()
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function goal_deadline_update({ goal_id, deadline_id }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function goal_deadline_delete({ goal_id, deadline_id }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------
